import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SurveyDefinition, WaitStepDefinition } from '../../../types/Survey';
import SurveyMarkdown from '../Components/SurveyMarkdown/SurveyMarkdown';
import IconImage from '../Components/IconImage/IconImage';
import { getIconImageStyles, getTextStyles } from '../Util/surveyStyles';
import { faRefresh } from '@fortawesome/pro-solid-svg-icons';

export interface WaitStepProps {
    step: WaitStepDefinition;
    surveyDefinition: SurveyDefinition;
}

export default function WaitStep({ step, surveyDefinition }: WaitStepProps) {
    const titleStyles = getTextStyles('title', surveyDefinition, step, true) as React.CSSProperties;
    const textStyles = getTextStyles('text', surveyDefinition, step, true) as React.CSSProperties;

    return (
        <div className="wait-step">
            <div className="current-step instruction-step">
                <div className="step-content">
                    <IconImage iconImage={step.iconImage} iconImageStyles={getIconImageStyles(surveyDefinition, step)} />
                    <div className="instruction-step">
                        {step.title && (
                            <div className="step-title" style={titleStyles}>
                                <SurveyMarkdown text={step.title} inline />
                            </div>
                        )}
                        {step.text && (
                            <div className="step-text" style={textStyles}>
                                <SurveyMarkdown text={step.text} />
                            </div>
                        )}
                    </div>
                    <div className="loading-indicator fa-2x">
                        <FontAwesomeIcon icon={faRefresh} spin />
                    </div>
                </div>
            </div>
        </div>
    );
}
